import { useRef, useState, useEffect } from "react";

export function VideoPlayer({ url, poster, classNames = "", sound = false }) {
  const videoRef = useRef(null);
  const wrapperRef = useRef(null);

  const [muted, setMuted] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  const toggleMute = () => {
    if (!videoRef.current) return;
    const nextMuted = !muted;
    videoRef.current.muted = nextMuted;
    setMuted(nextMuted);
  };

  useEffect(() => {
    if (!wrapperRef.current || !videoRef.current) return;

    const videoEl = videoRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!isLoaded) {
            videoEl.src = url;
            setIsLoaded(true);
          }

          videoEl.play().catch(() => {});
        } else {
          videoEl.pause();
        }
      },
      {
        threshold: 0.4,
        rootMargin: "0px",
      }
    );

    observer.observe(wrapperRef.current);

    return () => observer.disconnect();
  }, [url, isLoaded]);

  return (
    <div
      ref={wrapperRef}
      className={`player-wrapper ${classNames}`}
      onClick={toggleMute}
      style={{
        backgroundImage: poster ? `url(${poster})` : "none",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <video
        ref={videoRef}
        // poster={poster}
        loop
        playsInline
        muted
        preload="none"
      />

      {sound && (
        <button
          type="button"
          className="volume-button"
          onClick={(e) => {
            e.stopPropagation();
            toggleMute();
          }}
        >
          <img
            src={muted ? "/assets/mute.svg" : "/assets/volume.svg"}
            alt={muted ? "Muted" : "Unmuted"}
          />
        </button>
      )}
    </div>
  );
}
